<div *ngFor="let topNavBtn of topNavBtns" [attr.data-id]="topNavBtn.dataId">
  <top-nav-btn
    *ngIf="!topNavBtn.dropdownItems && canShowBtn(topNavBtn)"
    [btnDetails]="topNavBtn"
    [isBolded]="checkIfBolded(topNavBtn)"
  >
  </top-nav-btn>
  <top-nav-dropdown
    *ngIf="topNavBtn.dropdownItems && canShowBtn(topNavBtn)"
    [btnDetails]="topNavBtn"
    [isBolded]="checkIfBolded(topNavBtn)"
    [isAdmin]="isAdmin"
    [isRestrictedUser]="isRestrictedUser"
    [hasDataWall]="hasDataWall"
    [rgpTenantId]="rgpTenantId"
  >
  </top-nav-dropdown>
</div>
